
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Zip3Serve from "@/components/widgets/Zip3Serve.vue";
import * as modals from "@/lib/modals";

interface DefaultTruck {
  truckName: string;
  delDate: string;
  zipServed: string;
  driver: string;
  maxCubes: string;
  tripDays: string;
  status: string;
}

@Component({
  name: modals.newTruckModal,
  components: {
    Zip3Serve
  }
})
export default class NewTruck extends Vue {
  trucks: Array<any> = [];
  lastTruck: DefaultTruck = null;

  newTruck() {
    let truck: DefaultTruck = {
      truckName: "",
      delDate: "",
      zipServed: "",
      driver: "",
      maxCubes: "",
      tripDays: "1",
      status: ""
    };

    if (this.lastTruck) {
      truck.delDate = this.lastTruck.delDate;
      truck.maxCubes = this.lastTruck.maxCubes;
      truck.tripDays = this.lastTruck.tripDays;
      truck.maxCubes = this.lastTruck.maxCubes;
    }
    this.trucks.push(truck);
    this.lastTruck = truck;
  }

  deleteTruck(idx) {
    this.trucks.splice(idx, 1);
  }
}
